/** Visual weight pills for the stake ladder — top rank pops, bottom fades out. */
export function rungWeightStyle(weight: number, topWeight: number): {
  pill: string;
  text: string;
  beats: string;
} {
  if (weight >= topWeight) {
    return {
      pill: 'bg-accent shadow-[0_10px_20px_-9px_rgba(36,197,106,0.75)]',
      text: 'text-white',
      beats: 'text-accent-ink'
    };
  }
  if (weight >= topWeight - 1) {
    return { pill: 'bg-night', text: 'text-white', beats: 'text-accent-ink' };
  }
  if (weight >= topWeight - 2) {
    return { pill: 'bg-[#2A2A33]', text: 'text-white', beats: 'text-accent-ink' };
  }
  if (weight >= topWeight - 3) {
    return { pill: 'bg-[#E8E8EF]', text: 'text-ink', beats: 'text-ink3' };
  }
  if (weight >= topWeight - 4) {
    return { pill: 'bg-[#EFEFF4]', text: 'text-ink2', beats: 'text-ink3' };
  }
  return { pill: 'bg-[#F4F4F8]', text: 'text-ink3', beats: 'text-ink3' };
}
